module.exports = __webpack_public_path__ + "img/wisa_pc_03.181ae6c1.png";